export const BILLING_DETAILS_TEXTS = {
    BACK: 'Back',
    CEP: 'Cep',
    CITY: 'City',
    CNPJ: 'CNPJ',
    COUNTRY: 'Country',
    CREATED_SUCCESS: 'The billing information has been successfully saved',
    DISTRICT: 'District',
    EDITED_SUCCESS: 'The billing information has been successfully edited',
    EMAIL: 'Email',
    NUMBER: 'Number',
    PHONE_NUMBER: 'Phone number',
    STATE: 'State',
    STREET: 'Street',
    SUBMIT: 'Send',
    SUBTITLE: 'Please enter the information below',
    TAX_NUMBER: 'Tax number',
    TITLE: 'Billing details',
    POSTAL_CODE: 'Postal code',
};

export const BILLING_DETAILS_ERROR_KEYS = {
    NOT_FOUND: 'billing-details.retrieve.error.billing-details-not-found',
};

export const BILLING_DETAILS_ERROR_MESSAGES = {
    INVALID_CEP: 'Invalid cep',
    INVALID_CITY_SIZE: 'City is too big',
    INVALID_CNPJ: 'Invalid CNPJ',
    INVALID_DISTRICT_SIZE: 'District is too big',
    INVALID_EMAIL: 'Invalid e-mail address',
    INVALID_NUMBER_SIZE: 'Number is too big',
    INVALID_PHONE_NUMBER: 'Invalid phone number',
    INVALID_STATE_SIZE: 'State is too big',
    INVALID_STREET_SIZE: 'Street is too big',
    INVALID_TAX_NUMBER: 'Invalid tax number',
    REQUIRED_CEP: 'Cep is a required field',
    REQUIRED_CITY: 'City is a required field',
    REQUIRED_CNPJ: 'CNPJ is a required field',
    REQUIRED_COUNTRY: 'County is a required field',
    REQUIRED_DISTRICT: 'District is a required field',
    REQUIRED_EMAIL: 'E-mail address is a required field',
    REQUIRED_NUMBER: 'Number is a required field',
    REQUIRED_PHONE_NUMBER: 'Phone number is a required field',
    REQUIRED_STATE: 'State is a required field',
    REQUIRED_STREET: 'Street is a required field',
    REQUIRED_TAX_NUMBER: 'Tax Number is a required field',
    REQUIRED_POSTAL_CODE: 'Postal code is a required field',
};

export const BILLING_DETAILS_TEST_ID = {
    CITY: 'billing-details-city',
    TAX_NUMBER: 'billing-details-tax-number',
    CNPJ: 'billing-details-cnpj',
    SUBMIT: 'billing-details-submit',
    STATE: 'billing-details-state',
};

export const BRAZIL_COUNTRY_CODE = 'BRA';
